"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledOverlay = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: ", ";\n  z-index: ", ";\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.45);\n  opacity: ", ";\n  visibility: ", ";\n  transition-property: opacity, visibility;\n  transition-duration: 0.35s;\n"])), function (p) {
  return p.position;
}, function (props) {
  return props.zIndex || 9;
}, function (props) {
  return props.isVisible ? 1 : 0;
}, function (props) {
  return props.isVisible ? "visible" : "hidden";
});

var Overlay = function Overlay(_ref) {
  var onClick = _ref.onClick,
      isVisible = _ref.isVisible,
      zIndex = _ref.zIndex,
      position = _ref.position;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledOverlay, {
    onClick: onClick,
    zIndex: zIndex,
    isVisible: isVisible,
    position: position
  });
};

Overlay.defaultProps = {
  position: "fixed"
};
Overlay.propTypes = {
  position: _propTypes.default.string
};
var _default = Overlay;
exports.default = _default;